export default {
  bindings: {
    type: '<?',
    index: '<?',
    subsectionIndex: '<?',
    parent: '<?',
    class: '<?',
  },
  controller: function ctrl(
    TimelinesManager,
    _,
  ) {
'ngInject';
    const vm = this;
    vm.TimelinesManager = TimelinesManager;
    vm.openPopover = false;
  },
  controllerAs: 'vm',
  templateUrl: 'timelines/templates/nv-add-section-subsection-component.html',
};
